import config from "../js/config";


const baseUrl =
  process.env.NODE_ENV == "production"
    ? `${config.front_base}api`
    : "https://ygdk.buaa.edu.cn/api/";

  //https://ygdk.buaa.edu.cn/api/Front/Clockin/Msg/getMsgUnreadCount


const campusAppLogin = "/Front/Clockin/User/campusAppLogin";
const get_check_type_list = "/Front/Clockin/Classify/getList";
const get_check_list = "/Front/Clockin/Clockin/getList";
const banner_list = "/Front/Application/Banner/banner/getlist";
const praise_ = "/Front/Clockin/Clockin/praise";

const get_user_info = "/Front/Clockin/User/getUser";
const get_user_message = "/Front/Clockin/Msg/getMsgList";
const get_message_detail = "/Front/Clockin/Msg/getMsg";
const get_unread_message_count = "/Front/Clockin/Msg/getMsgUnreadCount";
const set_message_read = "/Front/Clockin/Msg/setMsgReaded";
const get_check_count = "/Front/Clockin/Clockin/getCount";
const get_sszs_list = "/Front/Clockin/CiMatch/getMatchList";
const get_clockin_term = "/Front/Clockin/Term/get";
const get_clockin_types = "/Front/Clockin/Item/getList";

const file_post = "/Front/Upload/File/post";
const clock_in = "/Front/Clockin/Clockin/clockin";
const get_notice = "/Front/Clockin/Notice/getByTypeAndClassify";
const get_item_detail = "/Front/Clockin/Clockin/get";

const get_square_list_count = "/Front/Application/Config/Config/getValue";

const get_notice_list = '/Front/Clockin/Info/getList'
const set_notice_mark = '/Front/Clockin/Info/setReaded'
const get_unread_notice_count  = '/Front/Clockin/Info/getUnreadCount'

export default {
  baseUrl,
  campusAppLogin,
  get_check_type_list,
  get_check_list,
  banner_list,
  praise_,
  get_user_info,
  get_user_message,
  get_message_detail,
  get_unread_message_count,
  set_message_read,
  get_check_count,
  get_sszs_list,
  get_clockin_term,
  get_clockin_types,
  file_post,
  clock_in,
  get_notice,
  get_item_detail,
  get_square_list_count,
  get_notice_list,
  set_notice_mark,
  get_unread_notice_count
};
